webpackJsonp([233698595820445],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 3: Learn about Markov language model'
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '60', max: '100' },
	          '60 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* A Markov language model predicts the next word based on the words that come before it. For example, the word "thank" has a high probability of being followed by "you," as evidenced in people\'s expressions. The model assumes that the probability of a word depends only on the immediate context. It\'s a simple and efficient way to generate text.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Worrying about writing code? We\'ve done it for you! Now you can run Google Colab below to see the predicted next word given the prompt of either "man" or "woman." After you go to Google Colab, select "Runtime->Run all". Under the section "Training with Bias", type either "man" or "woman" as the prompt and observe the next word. Repeat the process 10 times, 5 times with the prompt "man", and 5 times with "woman".'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://colab.research.google.com/drive/1hkzl1RfUJYYPaiDlos9ER6rYX4QJ9sTY?usp=sharing', title: 'Colab', target: '_blank' },
	            'Colab'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We\'re not done yet!'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/2-acquire/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/4-clean/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-3-rf-js-cfc433aa17118172ff27.js